import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center">
              <img src="/images/logo-markey.png" alt="CS AI" className="h-8 w-auto mr-2" />
            </div>
            <p className="mt-4 text-base text-gray-300">
              Solusi Customer Service berbasis AI terbaik untuk bisnis di Indonesia. 
              Tingkatkan kepuasan pelanggan dan efisiensi operasional Anda.
            </p>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-gray-300 tracking-wider uppercase mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#features" className="text-base text-gray-300 hover:text-white">
                  Fitur
                </a>
              </li>
              <li>
                <a href="#benefits" className="text-base text-gray-300 hover:text-white">
                  Manfaat
                </a>
              </li>
              <li>
                <a href="#testimonials" className="text-base text-gray-300 hover:text-white">
                  Testimoni
                </a>
              </li>
              <li>
                <a href="#pricing" className="text-base text-gray-300 hover:text-white">
                  Harga
                </a>
              </li>
              <li>
                <a href="#faq" className="text-base text-gray-300 hover:text-white">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-gray-300 tracking-wider uppercase mb-4">Hubungi Kami</h4>
            <ul className="space-y-2">
              <li className="flex items-center text-base text-gray-300">
                <Mail className="w-4 h-4 mr-2" />
                hello@sabisolution.com
              </li>
              <li className="flex items-center text-base text-gray-300">
                <Phone className="w-4 h-4 mr-2" />
                +62 821-8175-7601
              </li>
              <li className="flex items-start text-base text-gray-300">
                <MapPin className="w-4 h-4 mr-2 mt-1 flex-shrink-0" />
                <div className="text-sm">
                  Gedung Nucira Lt.1, Jofter-Prushaan
                  <br />
                  Jl. M.T. Haryono Kavling 27
                  <br />
                  Kel. Tebet Timur
                  <br />
                  Kec. Tebet Kota Adm. Jakarta Selatan
                  <br />
                  Provinsi DKI Jakarta
                </div>
              </li>
              {/* <li className="flex space-x-4 mt-4">
                <a href="#" className="text-gray-300 hover:text-white">
                  <Facebook className="w-5 h-5" />
                </a>
                <a href="#" className="text-gray-300 hover:text-white">
                  <Twitter className="w-5 h-5" />
                </a>
                <a href="#" className="text-gray-300 hover:text-white">
                  <Linkedin className="w-5 h-5" />
                </a>
              </li> */}
            </ul>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-base text-gray-400">
              &copy; 2025 CS AI. Semua hak dilindungi.
            </p>
            <div className="mt-4 md:mt-0 flex space-x-6">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-gray-300">Kebijakan Privasi</Link>
              <Link to="/terms-conditions" className="text-gray-400 hover:text-gray-300">Syarat & Ketentuan</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;